import React from "react";
import { Text, TouchableOpacity, StyleSheet } from "react-native";

import fontStyles from "../../../fonts";
import AddIcon from "../../common/icons/AddIcon";
import AppTheme from "../../AppTheme";

export default function AddElement({
  title = "Add element",
  style = {},
  onPress = () => {},
}) {
  return (
    <TouchableOpacity onPress={onPress} style={[styles.addButton, style]}>
      <AddIcon style={{ marginRight: 6 }} />
      <Text style={[fontStyles.h5medium, { color: AppTheme.DEFAULT_COLOR }]}>
        {title}
      </Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  addButton: {
    height: 34,
    width: 120,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    borderColor: AppTheme.DEFAULT_COLOR,
    borderWidth: 1,
    borderRadius: 100,
  },
});
